import React from 'react';
import Sidebar from './Sidebar';
import Header from './Header';

const Layout = ({ children, onLogout, isMobileMenuOpen, setIsMobileMenuOpen }) => {
    return (
        <div className="fixed inset-0 overflow-hidden bg-slate-50 flex font-sans text-slate-900">
            <Sidebar
                onLogout={onLogout}
                isMobileMenuOpen={isMobileMenuOpen}
                setIsMobileMenuOpen={setIsMobileMenuOpen}
            />

            <main className="flex-1 flex flex-col min-h-0 min-w-0 overflow-hidden">
                <Header onMenuClick={() => setIsMobileMenuOpen(true)} />

                <div className="flex-1 min-h-0 overflow-y-auto p-4 md:p-6 xl:p-8">
                    <div className="w-full max-w-[1600px] mx-auto">{children}</div>
                </div>
            </main>

            {isMobileMenuOpen && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-50 z-30 md:hidden"
                    onClick={() => setIsMobileMenuOpen(false)}
                ></div>
            )}
        </div>
    );
};

export default Layout;
